// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3jWl0","actions":"GroupTable_actions__2g_8l","deleteModalFooter":"GroupTable_deleteModalFooter__13sqi"};